import React from 'react';
import { Sidebar, type SidebarProps } from 'primereact/sidebar';
import { CloseButton, CloseButtonSize } from '../LiliCloseButton/CloseButton';
// ponytail: CSS imported at app-level index.css — bare imports here get tree-shaken by sideEffects:["*.css"]
import { twMerge } from 'tailwind-merge';
import { Heading } from '../../tokens';
export enum LiliDrawerPosition {
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM = 'bottom',
}

// See https://primereact.org/sidebar/ and add any additional props that you need
export interface LiliDrawerProps extends SidebarProps {
  visible: boolean;
  onHide: () => void;
  children: React.ReactNode;
  position?: LiliDrawerPosition;
  header?: string;
  width?: string;
  noHeader?: boolean;
  hideBorder?: boolean;
  showOverlay?: boolean;
  wrapperClassName?: string;
}

export const LiliDrawer = (props: LiliDrawerProps) => {
  const {
    visible,
    onHide,
    children,
    position = LiliDrawerPosition.RIGHT,
    header,
    width,
    noHeader,
    hideBorder,
    showOverlay = true,
    wrapperClassName,
    ...otherProps
  } = props;

  const renderSidebarContent = () => (
    <div className={twMerge('flex flex-col h-full', wrapperClassName)}>
      {!noHeader && (
        <div
          className={`flex items-center p-[16px] ${hideBorder ? '' : 'border-b border-outline-primary-bw-03'}`}>
          <CloseButton id='close-drawer' onClick={onHide} size={CloseButtonSize.Medium} />
          {header && <Heading.H10 className='flex-1 text-center pr-[28px]'>{header}</Heading.H10>}
        </div>
      )}
      <div className='h-full'>{children}</div>
    </div>
  );

  return (
    <Sidebar
      visible={visible}
      onHide={onHide}
      position={position}
      content={renderSidebarContent}
      style={{ width: width || '500px' }}
      showCloseIcon={false}
      modal={showOverlay}
      {...otherProps}
      pt={{
        ...otherProps.pt,
        mask: {
          ...otherProps.pt?.mask,
          className: [
            'lili-drawer-mask',
            (otherProps.pt?.mask as { className?: string })?.className,
          ]
            .filter(Boolean)
            .join(' '),
        },
      }}>
      {children}
    </Sidebar>
  );
};
